import React, { Component } from 'react';
import '../assets/css/bootstrap.min.css';
import '../assets/css/style.css';
import { Link } from 'react-router-dom';
import itemImg from '../assets/images/upcoming-collection-artwork-page/artwork-sample-1.png';
import Header from './Header';

class UpcomingCollection extends Component {
    render() {
        return (
            <div className="main-wrapper">
                {/* Header area start */}
                <Header />
                {/* Header area end */}

                {/* Upcoming Collection area start */}
                <div className="container margin-70 mb-5">
                    <div className="row collection">
                        <div className="col-lg-5 col-sm-0 upcoming-collection">
                            <img src={itemImg} alt="" width="100%" />
                            <h6><Link to="#">VIEW COLLECTION</Link>
                                <span>Contract Address</span>
                            </h6>
                            <h4><span>0xbfb69918f12eed843c67058b2ee9059f1440133e</span></h4>
                        </div>
                        <div className="col-lg-1 col-sm-0">
                        </div>
                        <div className="col-lg-6 col-sm-0 upcoming">
                            <h3>Artist Name</h3>
                            <h1>Artwork Title
                                <span>
                                    $8,000.00
                                </span>
                            </h1>
                            <hr />
                            <p>Collection Title
                                <span>Edition of 26</span>
                            </p>
                            <p>ITEM DESCRIPTION. Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam erat volutpat. Ut wisi enim ad minim veniam, quis nostrud exerci tation ullamcorper suscipit lobortis nisl ut aliquip ex ea commodo consequat. Duis autem vel eum iriure </p>
                            <div className="bid-rate">
                                <p>Dropping Soon</p>
                            </div>
                            <h4>0 editions purchased</h4>
                        </div>
                    </div>
                </div>
                {/* Upcoming Collection area end */}
            </div>
        )
    }
};

export default UpcomingCollection;